import { BaseQuestionnaireRoute } from '../slice';
import { theBasicRoutes, TheBasicsRoutes } from './the_basics';
import { WhereILiveRoutes, whereILiveRoutes } from './where_i_live';

export type PersonalDetailsRoutes = BaseQuestionnaireRoute & {
  the_basics: TheBasicsRoutes;
  where_i_live: WhereILiveRoutes;
};

export const personalDetailsRoutes: {
  personal_details: PersonalDetailsRoutes;
} = {
  personal_details: {
    title: 'Personal Details',
    path: 'personal_details',
    isValid: undefined,
    ...theBasicRoutes,
    ...whereILiveRoutes,
  },
};
